import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IconsModule, KENDO_ICONS, SVGIcon } from '@progress/kendo-angular-icons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ListViewDataResult, ListViewModule } from "@progress/kendo-angular-listview";
import {
  StoryPriority, StoryState, StoryType, UserStory, User as UserModel,
  CasiStoryStatus, CasiStoryPriority, CasiStoryType, CasiStoryEstimate, CasiUserStory, ICasiOwner,
  CasiUserStoryComment

} from '../../../../models/models.lib';
import { ButtonsModule, KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import { KENDO_LABELS, LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule, KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { LoggerService } from '../../../../shared/logger.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { globeIcon, thumbUpIcon } from '@progress/kendo-svg-icons';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { CommentSortOptions, CasiCloseOptions, StoryPriorities, StoryTypes } from '../../../../common/constants.lib';
import { AutoFocusDirective } from '../../../../directives/auto-focus.directive';
import { KENDO_EDITOR } from '@progress/kendo-angular-editor';
import { GridModule } from '@progress/kendo-angular-grid';
import { PagerModule } from '@progress/kendo-angular-pager';
import { CompositeFilterDescriptor, SortDescriptor } from '@progress/kendo-data-query';
import { CurrentItemCommentComponent } from '../current-item-comment/current-item-comment.component';
import { IconName, IconPrefix, IconProp } from '@fortawesome/fontawesome-svg-core';
import { KENDO_TOOLBAR } from '@progress/kendo-angular-toolbar';
import { MeService } from '../../../../auth/me.service';
import { DialogCloseResult, DialogModule, DialogService } from '@progress/kendo-angular-dialog';
import { ConfirmModalComponent } from '../../../../common-components/confirm-modal/confirm-modal.component';
import { UserStoryCommentsService } from '../../../user-story-comments.service';
import { UserStoryService } from '../../../user-story.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../environments/environment';
import { UserStoryOwnerService } from '../../../user-story-owner.service';
import { CasiKendoEditorComponent } from '../../../../common-components/casi-kendo-editor/casi-kendo-editor.component';
import { EditorImageUploadComponent } from '../../../../common-components/editor-image-upload/editor-image-upload.component';

const { apiUrl } = environment;

export const inlineEditTypes = {
  description: 'description',
  code: 'code',
  notset: 'notset'
};

@Component({
  selector: 'current-iteration-item',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ListViewModule,
    LayoutModule,
    InputsModule,
    FormsModule,
    ReactiveFormsModule,
    IconsModule,
    ButtonsModule,
    InputsModule,
    LabelModule,
    DropDownsModule,
    AutoFocusDirective,
    FontAwesomeModule,
    GridModule,
    PagerModule,
    KENDO_EDITOR,
    KENDO_DROPDOWNS, KENDO_LABELS, KENDO_ICONS,
    KENDO_BUTTONS,
    KENDO_TOOLBAR,
    CurrentItemCommentComponent,
    ConfirmModalComponent,
    CasiKendoEditorComponent,
    EditorImageUploadComponent
  ],
  templateUrl: './current-item.component.html',
  styleUrl: './current-item.component.scss'
})
export class CurrentItemComponent implements OnInit, OnDestroy, AfterContentInit {
  private _userStory: CasiUserStory | undefined;
  @Input({ required: true })
  set userStory(val: CasiUserStory) {
    this._userStory = val;
    // this.logger.debug(`input:userStory: `, this._userStory);
    this.formHeader.patchValue(this._userStory);
    this.form.patchValue(this._userStory);
    this.formDescription.patchValue(this._userStory);
    // this.formCode.patchValue(this._userStory);
    this.selectedType = this._userStory.user_story_type_id!;
    this.selectedPriority = this._userStory.user_story_priority_description!;
    this.selectedRequester = this._userStory.requested_by_user_id!;
    // this._userStory.owned_by_users_json?.forEach((u) => {
    //   let found = this.users.find((value, index, array) => {
    //     return
    //   });
    // });

    this.selectedOwners = this._userStory.owned_by_users_json!;
    this.selectedEstimate = this._userStory.user_story_estimate_id;
    this.selectedStatus = this._userStory.user_story_status_id!;
    this.selectTypeIconClass = this.setStoryIcons();
    // this.loadData();
    // this.commentService.get(this.userStory.id)
    //   .subscribe({
    //     next: resData => {
    //       this.rawData = resData;
    //       this.loadData();
    //     },
    //     error: err => {
    //       this.logger.error(`comments:error: `, err.message);
    //       this.rawData = [];
    //       this.loadData();
    //     }
    //   });
    // this.rawData = this._userStory.activitys!;
  }
  get userStory() {
    return (this._userStory as CasiUserStory);
  } //public userStory!: UserStory;

  private _storyTypes: CasiStoryType[] = [];
  @Input({ required: true }) set storyTypes(val: CasiStoryType[]) {
    this._storyTypes = val;
    this.setStoryIcons();
  }
  get storyTypes() {
    return this._storyTypes;
  } //storyTypes: StoryType[] = [];
  @Input({ required: true }) storyStatuses: CasiStoryStatus[] = [];
  @Input({ required: true }) storyPriorities: CasiStoryPriority[] = [];
  @Input({ required: true }) storyEstimates: CasiStoryEstimate[] = [];
  @Input({ required: true }) users: UserModel[] = [];
  @Input() projectUsers: any[] = [];
  @Input() selectedUserStoryId: string | null = null;
  @Output() refresh = new EventEmitter();

  @ViewChild("uploadDialog") public dialog: EditorImageUploadComponent = <EditorImageUploadComponent>{};

  public globeIcon: SVGIcon = globeIcon;
  // @Input({ required: true }) mode: FormModes = FormModes.NOTSET;

  formHeader: FormGroup;
  form: FormGroup;
  formComment: FormGroup;
  formDescription: FormGroup;
  // formCode: FormGroup;

  @ViewChild('pForm') pForm!: ElementRef;

  public selectedType: number | undefined; // = StoryTypes.Bug;
  public selectTypeIconClass: string | undefined;
  public selectedPriority: string | undefined; // = StoryPriorities.None;
  public selectedRequester: number | undefined;
  public selectedStatus: number | undefined;
  public selectedEstimate: number | undefined;
  public selectedOwners: any[] = []; // any = []; //ICasiOwner[] = [];
  public modUsers: any[] = [];
  public edvalue = '';
  public comvalue = '';
  //public ownerUsers: Array<{user_id: number, user_name: string, fullName: string}> = [];//ICasiOwner[] = []; //full list to select from
  public selectedSort: CommentSortOptions = CommentSortOptions.oldestToNewest; //  "Oldest to newest";

  public iconList: IconProp | undefined;
  public expandedState = false;
  public dataItems: Array<string> = ["Basketball", "Rugby", "Baseball"];
  // public expandCollapseContent(): void {
  //   this.logger.debug(`expandCollapseConent:`, this.expandedState);
  //   this.expandedState = !this.expandedState;
  // }
  public thumbUpIcon: SVGIcon = thumbUpIcon;
  public view: Observable<CasiUserStoryComment[]> = new Observable<CasiUserStoryComment[]>();

  public readonlyDescription: boolean = true;
  public readonlyCode: boolean = true;

  private _rawData: BehaviorSubject<CasiUserStoryComment[]> = new BehaviorSubject<CasiUserStoryComment[]>([]);
  get rawData$() {
    return this._rawData.asObservable();
  }
  get rawData() {
    return this._rawData.getValue();
  }
  set rawData(val: CasiUserStoryComment[]) {
    this._rawData.next(val);
  }
  public listView: ListViewDataResult | undefined;
  // public rawData: Observable<UserStoryComment[]> = new Observable<UserStoryComment[]>(); // UserStoryComment[] = [];
  public filter: CompositeFilterDescriptor = { logic: "and", filters: [] };
  // public gridData: UserStoryComment[] = filterBy(this.rawData, this.filter);

  public sortOptions: Array<CommentSortOptions> = [
    CommentSortOptions.newestToOldest,
    CommentSortOptions.oldestToNewest
  ];

  public sort: SortDescriptor[] = [
    {
      field: "name",
      dir: "asc",
    },
  ];

  private _subs: Subscription[] = [];
  private commentsFetched: boolean = false;
  private deletedOwner: boolean = false;

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
    private fb: FormBuilder,
    private meService: MeService,
    private dialogService: DialogService,
    private renderer: Renderer2,
    private el: ElementRef,
    private commentService: UserStoryCommentsService,
    private userStoryService: UserStoryService,
    private toastr: ToastrService,
    private userStoryOwnerService: UserStoryOwnerService
  ) {
    faIcons.addIcons(...all);
    this.form = this.fb.group(
      {
        id: [null, [Validators.required]],
        project_id: [null, [Validators.required]],
        project_name: [null, []],
        user_story_status_id: [null, [Validators.required]],
        user_story_status_description: [null, [Validators.required]],
        user_story_type_id: [null, [Validators.required]],
        user_story_type_description: [null, [Validators.required]],
        user_story_priority_id: [null, [Validators.required]],
        user_story_priority_description: [null, [Validators.required]],
        user_story_estimate_id: [null, [Validators.required]],
        user_story_estimate_description: [null, [Validators.required]],
        requested_by_user: [null, []],
        requested_by_user_id: [null, []],
        owned_by_users_json: [null, []],
        owned_by_users: [null, []],
        project_label_id: [null, []],
        project_label_description: [null, []],
        accepted_at: [null, []],
        deadline: [null, []],
        updated_by_user_id: [],
        updated_by_user: []
      }
    );
    this.formHeader = this.fb.group(
      {
        title: [null, [Validators.required]],
      }
    );
    this.formComment = this.fb.group(
      {
        toPost: [null, [Validators.required]]
      });
    this.formDescription = this.fb.group({
      description: [null, [Validators.required]]
    });
    // this.formCode = this.fb.group({
    //   code: [null, [Validators.required]]
    // });
  }

  //#region NG Event Handlers

  ngOnInit(): void {
    // this.logger.debug('ngOnInit...');
  }

  ngOnDestroy(): void {
    // this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  ngAfterContentInit(): void {
    // this.logger.debug('ngAfterContentInit...');
    if (this.selectedUserStoryId && this.selectedUserStoryId == this.userStory.id!.toString()) {
      this.expandedState = true;
      this.loadData();
    }

    this.logger.debug('ci projectUsers', this.projectUsers);

    this.projectUsers.forEach((pu) => {
      this.logger.debug('pu', pu);
      let found = this.users.find((value, index, array) => {

       // this.logger.debug('try to match user ', value);
        return pu.user_id == value.id;
      });
      if (found)
        this.modUsers.push({user_id: found.id, fullName: found.fullName, initials: found.initials, email: found.email});
    });
    this.logger.debug('modusers', this.modUsers);
    // this.users.forEach((u) => {
    //   this.modUsers.push({user_id: u.id, fullName: u.fullName, initials: u.initials});
    // });
    this.selectedOwners.forEach((o) => {
      // this.logger.debug('selected owner ', o);

     // this.modUsers = this.users;
      let found = this.users.find((value, index, array) => {

           // this.logger.debug('try to match user ', value);
            return o.user_id == value.id;
          });
          if (found) {
            // this.logger.debug('updating found', found);
            o.fullName = found.fullName;
            o.initials = found.initials;
            o.email = found.email;
          }
    });

    this.logger.debug('this.selectedOwners', this.selectedOwners);

    if (this.userStory.description)
      this.edvalue = this.userStory.description;
  }

  //#endregion

  //#region Form Properties

  get f() {
    return this.form.controls;
  }
  get fHeader() {
    return this.formHeader.controls;
  }
  get fComment() {
    return this.formComment.controls;
  }
  get fDescription() {
    return this.formDescription.controls;
  }
  // get fCode() {
  //   return this.formCode.controls;
  // }
  get titleIsDirty() {
    return this.formHeader.dirty;
  }
  get title() {
    return this.formHeader.get('title');
  }
  get user_story_status_id() {
    return this.form.get('user_story_status_id');
  }
  get user_story_status_id_value() {
    return this.form.get('user_story_status_id')?.value;
  }
  get user_story_status_description() {
    return this.form.get('user_story_status_description');
  }
  get user_story_status_description_value() {
    return this.form.get('user_story_status_description')?.value;
  }
  get user_story_type_id() {
    return this.form.get('user_story_type_id');
  }
  get user_story_type_id_value() {
    return this.form.get('user_story_type_id')?.value;
  }
  get user_story_type_description() {
    return this.form.get('user_story_type_description');
  }
  get user_story_priority_id() {
    return this.form.get('user_story_priority_id');
  }
  get user_story_priority_id_value() {
    return this.form.get('user_story_priority_id')?.value;
  }
  get user_story_priority_description() {
    return this.form.get('user_story_priority_description');
  }
  get user_story_priority_description_value() {
    return this.form.get('user_story_priority_description')?.value;
  }
  get user_story_estimate_id() {
    return this.form.get('user_story_estimate_id');
  }
  get user_story_estimate_id_value() {
    return this.form.get('user_story_estimate_id')?.value;
  }
  get user_story_estimate_description() {
    return this.form.get('user_story_estimate_description');
  }
  get user_story_estimate_description_value() {
    return this.form.get('user_story_estimate_description')?.value;
  }
  get requested_by_user() {
    return this.form.get('requested_by_user');
  }
  get requested_by_user_value() {
    return this.form.get('requested_by_user')?.value;
  }
  get requested_by_user_id() {
    return this.form.get('requested_by_user_id');
  }
  get requested_by_user_id_value() {
    return this.form.get('requested_by_user_id')?.value;
  }
  get owned_by_users() {
    return this.form.get('owned_by_users');
  }
  get description() {
    return this.formDescription.get('description');
  }
  get toPost() {
    return this.formComment.get('toPost');
  }

  //#endregion

  //#region Public functions

  public onExpand() {
    this.logger.debug(`onExpand...`, this.commentsFetched);
    if (!this.commentsFetched) {
      this.loadData();
    }
  }

  public onCollapse() {
    this.logger.debug(`onCollapse`);
  }

  public handleCommentDelete(userComment: CasiUserStoryComment): void {
    this.logger.debug('handleCommentDelete:userComment: ', userComment);
    this.removeUserComment(userComment);
  }

  public handleCommentSave(userComment: CasiUserStoryComment): void {
    this.logger.debug(`handleCommentSave:userComment: `, userComment);
    this.saveUserComment(userComment);
  }

  public emojiClick(evnt: any): void {
    this.logger.debug(`emojiClick...`, evnt);
  }

  public onTestChange(evnt: any): void {
    this.logger.debug(`onTestChange:evnt: `, evnt)
  }

  public onChange(value: string): void {
    this.logger.debug(`valueChange ${value}`);
    // this.form.patchValue({ title: value })
  }

  public sortSelectionChange(evnt: any) {
    this.logger.debug(`sortSelectionChange ${evnt}`);
    this.sortComment(evnt);
  }

  public selectionChange(evnt: any) {
    this.logger.debug(`selectionChange: `, evnt);
    this.userStory.user_story_type_description = evnt.user_story_type_description;
    this.userStory.user_story_type_id = evnt.id;
    this.selectedType = evnt.id;
    this.form.patchValue(this.userStory);
    this.saveUserStoryChanges();
    this.setStoryIcons();
  }

  private doNotify() {
    let byUser = this.meService.get()?.firstName;
    if (this.userStory.user_story_status_description == 'accepted' || this.userStory.user_story_status_description == 'rejected')
      this.userStoryOwnerService.notifyOwnersStatus(this.selectedOwners, this.userStory, byUser).then((result: any) => {
        this.toastr.success(`Status Updated, Story Owners Notified`);
        this.refresh.emit();
      }).catch((error: any) => {

      });

    if (this.userStory.user_story_status_description == 'finished' || this.userStory.user_story_status_description == 'delivered') {
      let requestor = this.users.find(u => u.id === this.selectedRequester);
      if (requestor)
        this.userStoryOwnerService.notifyRequestor(requestor, this.userStory, byUser).then((result: any) => {
          this.toastr.success(`Status Updated, Requestor Notified`);
          this.refresh.emit();
        }).catch((error: any) => {

        });
    }

  }

  public selectionStatusChange(evnt: any) {
    this.logger.debug(`selectionStatusChange: `, evnt);
    this.userStory.user_story_status_description = evnt.user_story_status_description;
    this.userStory.user_story_status_id = evnt.id;
    this.form.patchValue(this.userStory);
    this.saveUserStoryChanges();
    this.doNotify();

  }

  public selectionPriorityChange(evnt: any) {
    this.logger.debug(`selectionPriorityChange: `, evnt);
    this.userStory.user_story_priority_description = evnt.user_story_priority_description;
    this.userStory.user_story_priority_id = evnt.id;
    this.form.patchValue(this.userStory);
    this.saveUserStoryChanges();
  }

  public selectionEstimateChange(evnt: any) {
    this.logger.debug(`selectionEstimateChange: `, evnt);
    this.userStory.user_story_estimate_description = evnt.user_story_estimate_description;
    this.userStory.user_story_estimate_id = evnt.id;
    this.form.patchValue(this.userStory);
    this.saveUserStoryChanges();
  }

  public selectionRequesterChange(evnt: any) {
    this.logger.debug(`selectionRequesterChange: `, evnt);
    this.userStory.requested_by_user = (evnt as UserModel).fullName;
    this.userStory.requested_by_user_id = (evnt as UserModel).id;
    this.form.patchValue(this.userStory);
    this.saveUserStoryChanges();
  }

  private notifyComment(): Promise<any> {
    let uids: number[] = [];
    let users: UserModel[] = [];
    let byUser = this.meService.get()?.firstName;
    this.selectedOwners.forEach((o) => {
      if (o.user_id != this.meService.userId)
        uids.push(o.user_id);
    });
    if (this.selectedRequester && this.selectedRequester != this.meService.userId)
      uids.push(this.selectedRequester);
    uids.forEach((uid) => {
      let found = this.users.find((value) => {
        return value.id == uid;
      });
      if (found)
        users.push(found);
    });
    if (users.length > 0)
      return this.commentService.notifyComment(users, this.userStory, this.formComment.value.toPost, byUser);
    else
      return Promise.resolve(true);
  }

  public onPost(): void {
    this.logger.debug('onPost: ', this.formComment.value);
    let toSubmit = new CasiUserStoryComment({
      // id: this.lastId++,
      user_story_id: this.userStory.id,
      user_id: this.meService.userId,
      comment: this.formComment.value.toPost,
      // dateTime: new Date()
    });
    this.logger.debug('onPost: toSubmit', toSubmit);
    this.logger.debug('onPost: userStory', this.userStory);
    this.commentService.add(toSubmit)
      // .then(resp => {
      //   return this.notifyComment();
      // })
      .then(data => {
        this.commentsFetched = false;
        this.loadData();
        this.comvalue = '';
        this.formComment.patchValue({ toPost: '' });
        this.formComment.reset();
      })
      .catch(err => {
        this.logger.error(`onPost:error: `, err.message);
      })
    // if (!this.userStory.activities) {
    //   this.userStory.activities = []
    // }
    // this.userStory.activities?.push(toSubmit);
    // // this.rawData.push(toSubmit);
    // this.logger.debug('onPost: activities:', this.userStory.activities);
    // // this.logger.debug('onPost: rawData:', this.rawData);
    // // this.rawData = this.userStory.activitys!;
  }

  public inlineEditClicked(item: string): void {
    if (item === inlineEditTypes.description) {
      this.readonlyDescription = false;
    } else if (item === inlineEditTypes.code) {
      this.readonlyCode = false;
    }
  }

  public cancelInlineEdit(item: string): void {
    this.logger.debug(`cancelInlineEdit...`, item);
    if (item === inlineEditTypes.description) {
      if (this.formDescription.dirty) {

        const dialogRef = this.dialogService.open({
          content: ConfirmModalComponent,
          minWidth: 320,
          width: 750,
        });

        const contentRef = dialogRef.content.instance as ConfirmModalComponent;
        contentRef.title = "ABANDON CHANGES";
        contentRef.content = `Abandon your changes?`;

        dialogRef.result.subscribe((r: any) => {
          this.logger.debug('cancelChanges:result:', r);
          if (r instanceof DialogCloseResult) {
            return;
          }
          if (r.text === CasiCloseOptions.Ok) {
            this.logger.debug("cancelChanges:ok to proceed... ");
            this.formDescription.reset();
            this.readonlyDescription = true;
            this.formDescription.patchValue(this.userStory);
          }
        });
      } else {
        this.readonlyDescription = true;
      }

    } else if (item === inlineEditTypes.code) {
      // if (this.formCode.dirty) {

      //   const dialogRef = this.dialogService.open({
      //     content: ConfirmModalComponent,
      //     minWidth: 320,
      //     width: 750,
      //   });

      //   const contentRef = dialogRef.content.instance as ConfirmModalComponent;
      //   contentRef.title = "ABANDON CHANGES";
      //   contentRef.content = `Abandon your changes?`;

      //   dialogRef.result.subscribe((r: any) => {
      //     this.logger.debug('cancelChanges:result:', r);
      //     if (r instanceof DialogCloseResult) {
      //       return;
      //     }
      //     if (r.text === CasiCloseOptions.Ok) {
      //       this.logger.debug("cancelChanges:ok to proceed... ");
      //       this.formCode.reset();
      //       this.readonlyCode = true;
      //       this.formCode.patchValue(this.userStory);
      //     }
      //   });
      // } else {
      //   this.readonlyCode = true;
      // }
    }
  }

  public cancelTitleEdit(): void {
    this.logger.debug(`cancelTitleEdit...`,);
    this.formHeader.reset();
    this.formHeader.patchValue(this.userStory);
  }

  public saveInlineChanges(item: string): void {
    this.logger.debug(`saveDescriptionChanges...`, item); // this.formDescription.value);
    if (item === 'description') {
      this.userStory.description = this.formDescription.value.description;
      this.saveUserStoryChanges();
      // this.activity.description = this.form.value.description;
      this.readonlyDescription = true;
    } else if (item === 'code') {
      // this.userStory.code = this.formCode.value.code;
      // // this.activity.description = this.form.value.description;
      this.readonlyCode = true;
    }
  }

  public saveTitleChanges(): void {
    this.logger.debug(`saveTitleChanges...`, this.formHeader.value.title); // this.formDescription.value);
    this.userStory.title = this.formHeader.value.title;
    this.saveUserStoryChanges();
    this.formHeader.reset();
    this.formHeader.patchValue(this.userStory);
  }

  public cancelDescription(): void {
    this.logger.debug(`cancelDescription...`, this.form.dirty);
    if (this.form.dirty) {

      // const dialogRef = this.dialogService.open({
      //   content: ConfirmModalComponent,
      //   minWidth: 320,
      //   width: 750,
      // });

      // const contentRef = dialogRef.content.instance as ConfirmModalComponent;
      // contentRef.title = "ABANDON CHANGES";
      // contentRef.content = `Abandon your changes?`;

      // dialogRef.result.subscribe((r: any) => {
      //   this.logger.debug('cancelChanges:result:', r);
      //   if (r instanceof DialogCloseResult) {
      //     return;
      //   }
      //   if (r.text === CasiCloseOptions.Ok) {
      //     this.logger.debug("cancelChanges:ok to proceed... ");
      //     this.form.reset();
      //     this.readonlyFlag = true;
      //     this.form.patchValue(this.activity);
      //   }
      // });
    } else {
      this.readonlyDescription = true;
    }
    // this.form.reset();
    // this.readonlyFlag = true;
    // this.form.patchValue(this.activity);
    this.readonlyDescription = true;
  }

  public saveDescriptionChanges(): void {
    this.logger.debug(`saveDescriptionChanges...`, this.formDescription.value);
    this.userStory.description = this.formDescription.value.description;
    // this.activity.description = this.form.value.description;
    this.saveUserStoryChanges();
    this.readonlyDescription = true;
  }

  //#endregion

  //#region Grid functions

  public sortComment(option: CommentSortOptions) {
    this.logger.debug(`sortComment: `, option);
    if (option === CommentSortOptions.oldestToNewest) {
      this.sortCommentsDesc();
    } else {
      this.sortCommentAsc();
    }
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.logger.debug("sortChange: ", sort);
    this.sort = sort;
    this.sortComment(this.selectedSort); //CommentSortOptions.oldestToNewest);
    // this.loadData();
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    // this.logger.debug('filterChange: filter: ', filter);
    this.filter = filter;
    this.sortComment(this.selectedSort); //CommentSortOptions.oldestToNewest);
    //  this.loadData();
  }

  public copyStoryID(id: number): void {
    navigator.clipboard.writeText(id.toString());
    this.toastr.success(`Story ID ${id} copied to clipboard`);
  }

  public copyLink(us: CasiUserStory): void {
    this.logger.debug('us', us);
    let url = `${apiUrl}/tracker?projectId=${us.project_id}&storyId=${us.id}`;
    this.logger.debug('copy url', url);
    navigator.clipboard.writeText(url);
    this.toastr.success(`URL ${url} copied to clipboard`);
  }

  public onValueChange(value: any): void {
    this.logger.debug("valueChange", value);
    let byUser = this.meService.get()?.firstName;
    if (!this.deletedOwner && this.userStory.id) { //update
      this.userStoryOwnerService.bulkSetOwners(this.selectedOwners, this.userStory, byUser).then((result: any) => {
        this.toastr.success(`Story Owners Updated`);
        this.refresh.emit();
      }).catch((error: any) => {

      });
    }
    else
      this.deletedOwner = false; //clear
  }

  public onRemoveTag(tag: any) {
    this.logger.debug("removeTag", tag);
    if (this.userStory.id) {
      this.deletedOwner = true;
      this.userStoryOwnerService.deleteByUser(tag.dataItem.user_id, this.userStory.id).then((result: any) => {
        this.toastr.success(`Story Owners Updated`);
        this.refresh.emit();
      }).catch((error: any) => {

      });
    }
  }

  public valueChange(value: any): void {
     this.logger.debug(`valueChange...`, value);
      this.formDescription.patchValue({ description: value });
  }

  public commentValueChange(value: any): void {
    this.logger.debug(`valueChange...`, value);
    this.formComment.patchValue({ toPost: value });
    this.comvalue = value;
 }

  public openImageUpload() {
    setTimeout(() => this.dialog.open(), 200);
  }

  public onImageLoaded(args: any): void {
    this.logger.debug('onImageLoaded...', args);
    const { data } = args;
    // this.form.patchValue({ id: data });
    // this.opportunity.id = data;
  }
  // public distinctPrimitive(fieldName: string): any[] {
  //   // this.logger.debug('distinctPrimitive: fieldName: ', fieldName);
  //   return distinct(this.gridData, fieldName).map((item: any) => item[fieldName]);
  // }

  //#endregion

  //#region Private functions

  // private setSelectedUsers() {
  //   this.logger.debug(`setSelectedUsers...`);
  //   let selected: UserModel[] = [];
  //   if (this.userStory && this.users && this.userStory.owners!.length > 0) {
  //     for (let us of this.userStory.owners!) {
  //       this.logger.debug(`setSelectedUsers:us: `, us);
  //       let found = this.users.find((u: UserModel) => u.id === us);
  //       this.logger.debug(`setSelectedUsers:found: `, found);
  //       if (found)
  //         selected.push(found);
  //     }
  //   }
  //   return selected;
  // }

  private setListView(): void {
    if (this.rawData) {
      this.listView = undefined;
      setTimeout(() => {
        this.listView = <ListViewDataResult>{ data: this.rawData, total: this.rawData.length };
        this.logger.debug(`setListView:listView: `, this.listView);
      });
    }
  }

  private sortCommentsDesc(): void {
    if (this.rawData)
      this.rawData = this.rawData.sort((a, b) => a.id! - b.id!);
    // this.logger.debug(`sortCommentDesc:listView: `, this.listView, !!this.listView);
    // if (this.listView && this.listView.data && this.listView.data.length > 0) {
    //   //  this.listView.data = this.listView.data.sort((a, b) => a.id - b.id);
    //   this.logger.debug(`sortCommentDesc:rawData: `, this.rawData);
    //   this.listView.data = this.rawData; // newView; // this.listView.data.sort((a, b) => b.id - a.id);
    // }
    this.setListView();
    // this.listView = <ListViewDataResult>{ data: undefined, total: undefined };
    // this.listView = <ListViewDataResult>{ data: this.rawData, total: this.rawData.length };
    // this.logger.debug(`sortCommentDesc:listView: `, this.listView);
  }
  private sortCommentAsc(): void {
    if (this.rawData)
      this.rawData = this.rawData.sort((a, b) => b.id! - a.id!);
    // this.logger.debug(`sortCommentDesc:listView: `, this.listView, !!this.listView);
    // if (this.listView && this.listView.data && this.listView.data.length > 0) {
    //   // let newView = this.listView.data.sort((a, b) => b.id - a.id);
    //   this.logger.debug(`sortCommentDesc:rawData: `, this.rawData);
    //   this.listView.data = this.rawData; // newView; // this.listView.data.sort((a, b) => b.id - a.id);
    // }
    this.setListView();
    // this.listView = undefined;
    // this.listView = <ListViewDataResult>{ data: this.rawData, total: this.rawData.length };
    // this.logger.debug(`sortCommentDesc:listView: `, this.listView);

  }

  private loadData(): void {
    this.logger.debug('loadData...', this.userStory);
    if (!this.commentsFetched) {
      this.commentService.get(this.userStory.id!)
        .subscribe({
          next: resData => {
            this.rawData = resData;
            // this.loadData();
            this.sortComment(this.selectedSort); //CommentSortOptions.oldestToNewest);
            this.commentsFetched = true;
          },
          error: err => {
            this.logger.error(`comments:error: `, err.message);
            this.rawData = [];
            // this.loadData();
            this.sortComment(this.selectedSort); //CommentSortOptions.oldestToNewest);
          }
        });
    }

    // this.rawData = []; // this.userStory.activities!;
    // this.sortComment(this.selectedSort); //CommentSortOptions.oldestToNewest);
    // this.logger.debug('loadData...listView:', this.listView);
    // this.gridData = orderBy(filterBy(this.rawData, this.filter), this.sort);
  }

  private setStoryIcons(): any {
    // this.logger.debug(`setStoryIcons...storyTypes:`, this.storyTypes);
    // this.logger.debug(`setStoryIcons...selectedType`, this.selectedType);
    if (this.storyTypes) {
      let found = this.storyTypes.find(st => st.id === this.selectedType);
      if (found) {
        this.iconList = [('fad' as IconPrefix), (found.icon as IconName)];
        setTimeout(() => {
          this.selectTypeIconClass = found.iconClass;
        });
      }
      // this.logger.debug(`setStoryIcons: selectTypeIcons`, this.selectTypeIconClass);
    }
  }

  private findUserComment(userComment: CasiUserStoryComment): CasiUserStoryComment | undefined {
    // return undefined;
    return this.rawData?.find(a => a.id === userComment.id);
  }

  private saveUserComment(userComment: CasiUserStoryComment): void {
    this.logger.debug(`saveUserComment:userComment: `, userComment);
    let found = this.findUserComment(userComment); //  this.userStory.activitys?.find(a => a.id === userComment.id);
    if (found) {
      this.logger.debug(`sveUserComment:found: `, found);
      found = Object.assign(found, userComment);
      this.logger.debug(`sveUserComment:found: updated: `, found);
      this.commentService.update(userComment)
        .then(resp => {
          // Commented out for the moment
          // this.loadData();
          // this.commentService.query(this.userStory.id);
        })
        .catch(err => {
          this.logger.error(`saveUserComment:error: `, err.message);
        });
    }
    // this.loadData();
  }

  private removeUserComment(userComment: CasiUserStoryComment): void {
    this.logger.debug(`removeUserComment:userComment: `, userComment);
    this.commentsFetched = false;
    this.commentService.destroy(userComment.id!)
      .then(resp => {
        this.logger.debug(`removeUserComment:resp: `, resp);
        this.loadData();
        // this.commentService.query(this.userStory.id);
      })
      .catch(err => {
        this.logger.error(`removeUserComment: `, err.message);
      });
    // let found = this.findUserComment(userComment); //  this.userStory.activitys?.find(a => a.id === userComment.id);
    // if (found) {
    //   this.logger.debug(`removeUserComment:found: `, found);
    //   /**
    //    * Commented out so it doesn't actually remove comments
    //    */
    //   this.commentService.destroy(userComment.id!)
    //     .then(resp => {
    //       this.loadData();
    //       // this.commentService.query(this.userStory.id);
    //     })
    //     .catch(err => {
    //       this.logger.error(`removeUserComment: `, err.message);
    //     });
    // }
  }

  private saveUserStoryChanges() {
    let toSave = this.buildToSave();
    this.logger.debug(`saveUserStoryChanges...`, toSave);
    this.userStoryService.update(toSave)
      .then(resp => {
        this.setStoryIcons();
      })
      .catch(err => {

      });
  }

  private buildToSave(): CasiUserStory {
    this.logger.debug(`buildToSave...`, this.form.value, this.formDescription.value, this.formHeader);
    let toSave = { ...this.form.value, ...this.formDescription.value, ...this.formHeader.value };
    this.logger.debug(`buildToSave: toSave: `, toSave);
    return new CasiUserStory(toSave);
  }

  //#endregion

}
